<template>
  <div>
    <wishlist></wishlist>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Wishlist from "../components/organisms/wishlist";
export default {
  name: "WishlistPage",
  components: { Wishlist },
  data() {
    return {
      cart: null
    };
  },
  methods: {
    async getCart() {
      const cartId = this.$route.params.id;
      if (cartId) {
        //Implement stored cart
        // const response = await getCartInfo();
        // if (response.status === 200) {
        //   this.product = response.data;
        // } else {
        //   this.handleHttpError(response);
        // }
      }
    },
    ...mapMutations({
      setLocalCart: "cart/setCart"
    })
  },
  beforeMount() {
    this.getCart();
  }
};
</script>

<style scoped></style>
